import { queryOptions } from "@tanstack/react-query";
import { client } from "$api/client";

export const queryDaysBlockChange = (municipalId) =>
  queryOptions({
    queryKey: ["daysBlockChange"],
    queryFn: async () => {
      const relevantItems = await client.get(
        `/municipal_utility/${municipalId}/blocking_period`
      );
      return relevantItems?.data;
    },
  });
